module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "u-d-flex flex-state-buttons p-executive-dashboard__claim-numbers"
  }, [_c('h2', {
    staticClass: "u-margin-top-10 u-r-no-margin"
  }, [_vm._v("\n            Claim Numbers\n        ")]), _vm._v(" "), (!_vm.diseaseTypeSelected) ? _c('option-filters', [_c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'total'
    },
    on: {
      "click": function($event) {
        _vm.chartType = 'total'
      }
    }
  }, [_vm._v("\n                By Type\n            ")]), _vm._v(" "), _c('li', {
    class: {
      'm-option-filters--active': _vm.chartType === 'caseNumbersTrendChartData'
    },
    on: {
      "click": function($event) {
        _vm.chartType = 'trend'
      }
    }
  }, [_vm._v("\n                Trends by Numbers\n            ")])]) : _vm._e()], 1), _vm._v(" "), (_vm.chartType === 'total' && !_vm.diseaseTypeSelected) ? _c('summary-charts', {
    attrs: {
      "type": "number",
      "run-type": "averageReserve",
      "chart-data": _vm.caseNumbersChartData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chartType === 'trend' || _vm.diseaseTypeSelected) ? _c('trends-chart', {
    attrs: {
      "type": "number",
      "showing": "total",
      "chart-data": _vm.caseNumbersTrendChartData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6960e092!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/executive-dashboard/components/NumbersSection.vue
// module id = 1728
// module chunks = 0